import IframePage from '../IframePage';

const MementoIframePage: React.FC = (props: any) => {
  return (
    <IframePage
      {...props}
      url="https://api.appcraft.events/custom/v1/{eventId}/memento/k/{privateKey}"
    />
  );
};

export default MementoIframePage;
